import { Card } from '@/components/shadcn-ui/card';

import { getLotById } from '@/network/api.service';
import { ChevronRight, Pencil } from 'lucide-react';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

const PreProcessDetailPage = () => {
  const [lot, setLot] = useState(null);

  const { id } = useParams();

  const fetchLot = useCallback(async () => {
    // setPageLoading(true);
    const { data } = await getLotById(id, false);

    if (data?.data) {
      setLot(data.data);
    }

    // setPageLoading(false);
  }, [id]);

  useEffect(() => {
    fetchLot();
  }, [id]);

  const formatStage = (stage = '') => stage.replace(/([a-z])([A-Z])/g, '$1 $2');

  return (
    <div className="flex flex-1 flex-col space-y-[18px] px-4 py-[18px]">
      {/* Lot Information */}
      <Card className="rounded-2xl px-4 py-5 shadow-sm">
        <div className="mb-2 flex items-start justify-between">
          <div className="text-base font-semibold">Lot Information</div>
          <div className="rounded-full bg-primary px-3 py-1 text-xs text-white">{formatStage(lot?.stage)}</div>
        </div>

        <div className="space-y-1 text-sm">
          <div>
            <span className="font-semibold">Lot:</span> {lot?.lotname}
          </div>
          <div>
            <span className="font-semibold">Estate:</span> {lot?.estate?.name || lot?.estate_id?.name}
          </div>
          <div>
            <span className="font-semibold">Varietal:</span> {lot?.varietal}
          </div>
          <div>
            <span className="font-semibold">Weight of coffee:</span> {lot?.weight_of_coffee} Kg
          </div>
          <div>
            <span className="font-semibold">Date of harvest: </span>
            {new Date(lot?.date_of_harvest).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </div>
          <div>
            <span className="font-semibold">Date of sourcing: </span>
            {new Date(lot?.date_of_sourcing).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </div>
        </div>
      </Card>

      {/* Pre-process */}
      <Card className="rounded-2xl px-4 py-5 shadow-sm">
        <div className="mb-2 flex items-start justify-between">
          <div className="text-base font-semibold">Pre-process</div>
          <Link to={`/pre-process/detail/${id}/update`}>
            <Pencil className="size-5" />
          </Link>
        </div>
        <div className="space-y-1 text-sm">
          <div>
            <span className="font-semibold">Winnower waste:</span> {lot?.pre_process_data?.winnower_waste_kg ?? 'N/A'}{' '}
            Kg
          </div>
          <div>
            <span className="font-semibold">Siphon rejects:</span> {lot?.pre_process_data?.siphon_rejects_kg ?? 'N/A'}{' '}
            Kg
          </div>
          <div>
            <span className="font-semibold">Unripe coffees:</span> {lot?.pre_process_data?.unripe_coffees_kg ?? 'N/A'}{' '}
            Kg
          </div>
          <div>
            <span className="font-semibold">Ripe coffees:</span>{' '}
            {lot?.pre_process_data?.ripe_coffee_for_processing_kg || 'N/A'} Kg
          </div>
          <div>
            <span className="font-semibold">Pre-processing date: </span>
            {lot?.pre_process_data?.completion_of_pre_processing_at
              ? new Date(lot?.pre_process_data?.completion_of_pre_processing_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })
              : 'N/A'}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PreProcessDetailPage;
